import React from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";
import "./index.scss";

const DateOrderedCell = ({ value }) => {
  const formattedDate = format(new Date(value), "dd MMMM, yyyy");
  return (
    <div data-testid="date-ordered-cell" className="date-ordered-cell">
      <div className="details">
        <span className="name">{formattedDate}</span>
      </div>
    </div>
  );
};

DateOrderedCell.propTypes = {
  value: PropTypes.string.isRequired,
};

export default DateOrderedCell;
